import { Sun, Factory } from "lucide-react";
import { Switch } from "../ui/switch";
import { storageStatus } from "./simulation";

export function ThermalReadouts({ snapshot, running, copy }) {
  const energy = Math.round(snapshot.energy);
  const status = storageStatus(snapshot, running);
  return (
    <div className="grid sm:grid-cols-3 gap-6 border-y border-white/10 py-6" data-testid="thermal-readouts">
      <div>
        <p className="text-xs text-steel" data-testid="receiver-temperature-label">{copy.temperature}</p>
        <p className="mt-2 text-2xl font-display text-red-400 tabular-nums" data-testid="receiver-temperature">{Math.round(snapshot.temperature)} °C</p>
      </div>
      <div>
        <div className="flex justify-between gap-3 text-xs"><span className="text-steel" data-testid="storage-energy-label">{copy.storage}</span><span className="text-volt tabular-nums" data-testid="storage-level">{energy}%</span></div>
        <div role="progressbar" aria-label={copy.storage} aria-valuenow={energy} aria-valuemin={0} aria-valuemax={100} className="h-1.5 mt-3 bg-white/10 rounded-full overflow-hidden" data-testid="storage-progress">
          <div className="h-full bg-volt transition-[width] duration-200" style={{ width: `${snapshot.energy}%` }} />
        </div>
        <p className="mt-2 text-xs text-steel" data-testid="storage-status">{copy[status]}</p>
      </div>
      <div>
        <p className="text-xs text-steel" data-testid="process-heat-label">{copy.delivery}</p>
        <p className={`mt-2 text-sm font-medium ${snapshot.output > 0 && running ? "text-volt" : "text-steel"}`} data-testid="process-heat-status">
          {running ? snapshot.output > 0.005 ? copy.active : copy.standby : copy.paused}
        </p>
      </div>
    </div>
  );
}

export function ThermalControls({ solar, setSolar, demand, setDemand, copy }) {
  return (
    <div className="space-y-7" data-testid="thermal-controls">
      <div>
        <div className="flex items-center justify-between gap-3 mb-4 text-sm">
          <label htmlFor="thermal-solar" className="flex items-center gap-2"><Sun size={17} className="text-yellow-300" />{copy.solar}</label>
          <output htmlFor="thermal-solar" className="text-volt tabular-nums" data-testid="solar-intensity-value">{solar}%</output>
        </div>
        <input id="thermal-solar" type="range" min="0" max="100" step="1" value={solar} onChange={e => setSolar(Number(e.target.value))}
          className="w-full h-6 accent-[#00ff88] cursor-pointer focus-visible:outline focus-visible:outline-2 focus-visible:outline-volt"
          data-testid="solar-intensity-slider" />
      </div>
      <div className="flex items-center justify-between gap-5">
        <label htmlFor="thermal-demand" className="flex items-center gap-2 text-sm"><Factory size={17} className="text-volt" />{copy.use}</label>
        <Switch id="thermal-demand" aria-label={copy.use} checked={demand} onCheckedChange={setDemand} data-testid="industrial-heat-toggle" />
      </div>
    </div>
  );
}